export const UploadPageSideTranslation = new Map<string, string>([
    ['Front', 'UploadSidePage.Front'],
    ['Back', 'UploadSidePage.Back'],
    ['Main', 'UploadSidePage.Main'],
    ['First', 'UploadSidePage.First'],
]);
